module.exports = __webpack_public_path__ + "static/media/cat_sneeuwvlok.1756c4f2.png";